import { TimePicker } from "@design-system/TimePicker/TimePicker";
import type {
    DataGridListDurationEdit,
    DataGridListEditorProps,
} from "../../../columns/listEditors";
import { ListEditTrigger } from "../ListEditTrigger";
import { toCloseAndCommit } from "../listEditActions";

interface DurationListEditorProps<
    TData,
> extends DataGridListEditorProps<TData> {
    edit: DataGridListDurationEdit<TData>;
}

/**
 * `col.edit.duration`: the `TimePicker` on the cell, with its presets and
 * parsing. A pick closes it, then commits the minutes; removing commits `null`.
 */
export const DurationListEditor = <TData,>({
    row,
    trigger,
    isOpen,
    onOpenChange,
    onCloseAndCommit,
    edit,
}: Readonly<DurationListEditorProps<TData>>) => {
    const commit = toCloseAndCommit({ edit, row, onCloseAndCommit });
    return (
        <TimePicker
            open={isOpen}
            onOpenChange={onOpenChange}
            value={edit.value(row) ?? undefined}
            onChange={(minutes) => commit(minutes ?? null)}
            isClearable={edit.isClearable}
            label={edit.label}
            removeLabel={edit.removeLabel}
            trigger={<ListEditTrigger {...trigger} />}
        />
    );
};
